<template>
  <div class="app-container">
    <NavBar />
    <div class="main-content" :class="{ 'has-padding': !isHomePage }">
      <router-view />
    </div>


    <div class="qrcode-container">
      <div class="qrcode-ma">
        <img src="@/assets/home/qrcode.png" alt="">
        <!-- <p style="color: #3279FF;">扫描二维码，填写您的故障信息</p> -->
      </div>

      <div class="qrcode"></div>
      <p class="qrcode-title">故障上报</p>
    </div>
  </div>
</template>

<script>
import { ref, provide, onMounted } from "vue";
import NavBar from './components/NavBar.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: 'App',
  components: {
    NavBar
  },
  setup() {

    const windowWidth = ref(window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth);
    const windowHeight = ref(window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight);

    const route = useRoute();

    provide("windowWidth", windowWidth.value)
    provide("windowHeight", windowHeight.value)

    // 判断是否在首页
    const isHomePage = computed(() => {
      return route.path === '/' || route.path === '/home' || route.path === '/swiperHome';
    });


    // 页面加载时滚动到顶部
    onMounted(() => {
      // 立即滚动
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      setTimeout(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }, 100);

      setTimeout(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }, 300);
    });

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        setTimeout(() => {
          window.scrollTo(0, 0);
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
        }, 100);
      }
    });

    window.addEventListener('resize', function () {
      // 处理窗口大小变化的逻辑代码
      windowWidth.value = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth);
      windowHeight.value = (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight);
    });

    return {
      isHomePage,
      windowWidth,
      windowHeight
    }
  }
}
</script>

<style lang="scss">
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
} */

.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  flex: 1;
}

/* 只有非首页内容添加顶部内边距 */
.main-content.has-padding {
  padding-top: 80px;
  /* 为固定导航栏留出空间，与导航栏高度相同 */
}

/* 确保下拉菜单在滚动后正常显示 */
.el-popper.el-dropdown__popper {
  z-index: 3000 !important;
}

ul,
li {
  list-style: none;
}

$qecode: 66px;

.qrcode-container {
  width: $qecode;
  /* height: 88px; */
  position: fixed;
  bottom: 104px;
  right: 64px;
  z-index: 999;
  cursor: pointer;
  /* background: linear-gradient(129deg, #FFFFFF 0%, rgba(247, 245, 245, 0.973) 47%, #FFFFFF 100%);
  border-radius: 21px 21px 21px 21px;
  border: 2px solid rgba(255, 255, 255, 0.31); */

  .qrcode {
    width: 100%;
    height: $qecode;
    background: url('@/assets/home/qrcode-icon.png');
    background-size: 100% 100%;
    margin-bottom: 8px;

  }

  .qrcode-title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #9E9DF1;
    line-height: 22px;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }

  .qrcode-ma {
    display: none;
    position: absolute;
    left: -40%;
    bottom: 110%;
    width: 114px;
    padding: 8px;
    background: #fff;
    border-radius: 10px;
    transition: all 0.3s ease;

    img {
      width: 100%;
    }
  }

  .qrcode-ma::after {
    position: absolute;
    right: 40%;
    bottom: -5%;
    content: '';
    border-right: 10px solid transparent;
    border-top: 10px solid #fff;
    border-left: 10px solid transparent;
  }
}

.qrcode-container:hover .qrcode-ma {
  display: block;
}

/* 全局样式：为非首页添加导航栏空间 - 只在移动端生效 */
@media (max-width: 768px) {
  body:not(.home-page) {
    padding-top: 50px; /* 移动端导航栏高度调整 */
  }
}

@media (max-width: 480px) {
  body:not(.home-page) {
    padding-top: 40px; /* 超小屏导航栏高度调整 */
  }
}
</style>
